module.exports = __webpack_public_path__ + "img/电子招标标识.ea6e7026.png";